import React from 'react';
import PropTypes from 'prop-types';

import ListItem from './ListItem';

const ListItems = ({
  handleSelection,
  items = [],
  selectedItems = [],
  handleExpendTree,
  position,
  activationKey,
}) => {
  const renderList = () =>
    items.map(item => {
      item.selected = selectedItems && selectedItems.indexOf(item.itemId) >= 0;
      return (
        <ListItem
          key={item.itemId}
          {...item}
          listid={item.id}
          handleSelection={handleSelection}
          handleExpendTree={handleExpendTree}
          position={position}
          activationKey={activationKey}
        />
      );
    });

  return (
    <div className="multi-select-list">
      <ul
        className="vertical dropdown menu user-select-none"
        data-dropdown-menu
      >
        {renderList()}
      </ul>
    </div>
  );
};

ListItems.propTypes = {
  handleSelection: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  selectedItems: PropTypes.instanceOf(Array),
  handleExpendTree: PropTypes.func,
  position: PropTypes.string,
  activationKey: PropTypes.bool,
};

export default ListItems;
